import React from "react";
import cc from "classcat";
import PropTypes from "prop-types";
import Spinner from "./Spinner";
CentralLoader.propTypes = {
    show: PropTypes.bool,
    size: PropTypes.string,
    className: PropTypes.string,
    withSpinner: PropTypes.bool
};
export default function CentralLoader(param) {
    var _param_show = param.show, show = _param_show === void 0 ? true : _param_show, className = param.className, _param_withSpinner = param.withSpinner, withSpinner = _param_withSpinner === void 0 ? true : _param_withSpinner, _param_size = param.size, size = _param_size === void 0 ? "large" : _param_size;
    return /*#__PURE__*/ React.createElement("div", {
        className: cc([
            "absolute left-0 top-0 z-10 h-full w-full bg-black bg-opacity-30 transition",
            {
                "invisible opacity-0": !show,
                "opacity-1": show
            },
            className
        ])
    }, withSpinner ? /*#__PURE__*/ React.createElement("div", {
        className: "flex h-full items-center justify-center"
    }, /*#__PURE__*/ React.createElement(Spinner, {
        size: size,
        variant: "secondary"
    })) : null);
}
